import {createContext, FC, RefObject, useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";
import Tracker from '@openreplay/tracker';
import trackerFetch from '@openreplay/tracker-fetch';
import trackerGraphql from '@openreplay/tracker-graphql';
import {Scalars} from "../../.cache/__types__";

export const TrackerContext = createContext<{
    start: Function,
    setUser: Function,
    isTracking: boolean,
    recordGraphQLRef: RefObject<Function>,
}>({
    start: () => {},
    setUser: (user: Scalars['ID']) => {},
    isTracking: false,
    recordGraphQLRef: {
        current: null,
    },
});

function newTracker() {
    return new Tracker({
        projectKey: process.env.NEXT_PUBLIC_OPENREPLAY_PROJECT_KEY ?? '',
    });
}

export const useOpenReplay = () => {
    return useContext(TrackerContext);
}

export const TrackerProvider: FC = ({children}) => {
    const recordGql = useRef<Function>(null);
    const tracker = useMemo(() => newTracker(), []);

    const start = useCallback(() => tracker.start(), [tracker]);
    const setUser = useCallback((user: Scalars['ID']) => tracker.setUserID(user), [tracker]);

    useEffect(() => {
        tracker.use(trackerFetch({
            overrideGlobal: true,
        }));
        // @ts-ignore
        recordGql.current = tracker.use(trackerGraphql());
    }, [tracker]);

    const isActive = tracker.isActive();

    const value = useMemo(() => ({
        start,
        setUser,
        isTracking: isActive,
        recordGraphQLRef: recordGql,
    }), [isActive, start, setUser]);

    return <TrackerContext.Provider value={value}>{children}</TrackerContext.Provider>
}
